/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommentMentionNotificationActionData
 */
export interface CommentMentionNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof CommentMentionNotificationActionData
     */
    type: CommentMentionNotificationActionDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentMentionNotificationActionData
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentMentionNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentMentionNotificationActionData
     */
    commentUserId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentMentionNotificationActionData
     */
    commentId?: string;
}


/**
 * @export
 */
export const CommentMentionNotificationActionDataTypeEnum = {
    Track: 'Track',
    Playlist: 'Playlist',
    Album: 'Album'
} as const;
export type CommentMentionNotificationActionDataTypeEnum = typeof CommentMentionNotificationActionDataTypeEnum[keyof typeof CommentMentionNotificationActionDataTypeEnum];


/**
 * Check if a given object implements the CommentMentionNotificationActionData interface.
 */
export function instanceOfCommentMentionNotificationActionData(value: object): value is CommentMentionNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "commentUserId" in value && value["commentUserId"] !== undefined;

    return isInstance;
}

export function CommentMentionNotificationActionDataFromJSON(json: any): CommentMentionNotificationActionData {
    return CommentMentionNotificationActionDataFromJSONTyped(json, false);
}

export function CommentMentionNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentMentionNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'entityId': json['entity_id'],
        'entityUserId': json['entity_user_id'],
        'commentUserId': json['comment_user_id'],
        'commentId': !exists(json, 'comment_id') ? undefined : json['comment_id'],
    };
}

export function CommentMentionNotificationActionDataToJSON(value?: CommentMentionNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'entity_id': value.entityId,
        'entity_user_id': value.entityUserId,
        'comment_user_id': value.commentUserId,
        'comment_id': value.commentId,
    };
}

